import {SxProps} from '@mui/material';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';

import {Routes} from '../../constants/routes';
import {AdministrationPageItem} from '@pages/AdministrationPage/types';
import {makeAdminRoutes, makeSideMenuItem} from '@pages/AdministrationPage/utils';
import AccountsPage from '@pages/AccountsPage/AccountsPage';
import {ReactComponent as ListEditOutlined} from '@assets/icons/ListEditOutlined.svg';
import NciAdministrationPage from '@pages/NciAdministrationPage/NciAdministrationPage';
import {Permission} from 'utils/hooks/permissions/usePermissions';
import {HelpOutline} from '@mui/icons-material';
import TechnicalSupportPage from '@pages/TechnicalSupport/TechnicalSupportPage';

export const STYLES: Record<string, SxProps> = {
    wrapper: {
        position: 'fixed',
        top: '70px',
        left: 0,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    menu: {
        width: '64px',
        height: '100vh',
        backgroundColor: 'transparent',
        borderRight: '1px solid var(--mui-palette-divider)',
        padding: '32px 12px',
        paddingLeft: '11px',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        padding: '0 16px',
        width: '100%',
        overflow: 'auto',
    },
};

export const ADMINISTRATOR_PAGES: AdministrationPageItem[] = [
    {
        route: Routes.Accounts,
        label: 'users',
        icon: <AccountBoxOutlinedIcon />,
        element: <AccountsPage />,
    },
    {
        route: Routes.NciAdministration,
        label: 'nciAdmin',
        icon: <ListEditOutlined />,
        element: <NciAdministrationPage />,
        requiredPermission: Permission.CAN_ADMIN_NCI_EDIT,
    },
    {
        route: Routes.TechnicalSupport,
        label: 'supportTickets',
        icon: <HelpOutline />,
        element: <TechnicalSupportPage />,
    },
];

export const MENU_ITEMS = ADMINISTRATOR_PAGES.map(
    ({label, route, icon, requiredPermission}: AdministrationPageItem) =>
        makeSideMenuItem(label, route, icon, requiredPermission),
);

export const ADMIN_ROUTES = ADMINISTRATOR_PAGES.map(({route, element}) =>
    makeAdminRoutes(route, element),
);
